"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircuitBreakerState = void 0;
var CircuitBreakerState;
(function (CircuitBreakerState) {
    CircuitBreakerState[CircuitBreakerState["CLOSED"] = 0] = "CLOSED";
    CircuitBreakerState[CircuitBreakerState["OPEN"] = 1] = "OPEN";
    CircuitBreakerState[CircuitBreakerState["HALF_OPEN"] = 2] = "HALF_OPEN";
})(CircuitBreakerState = exports.CircuitBreakerState || (exports.CircuitBreakerState = {}));
//# sourceMappingURL=types.js.map